import { Button, Stack, Typography } from '@mui/material';

type HeaderWithButtonProps = {
  header: string;
  buttonLabel?: string;
  infoIcon?: React.ReactNode;
  onClick: () => void;
};

export const HeaderWithButton = (props: HeaderWithButtonProps) => {
  const { header, buttonLabel = 'Set Defaults', onClick } = props;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography component="h6" variant="h6">
        {header}
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        {props.infoIcon}
        <Button size="small" onClick={onClick}>
          {buttonLabel}
        </Button>
      </Stack>
    </Stack>
  );
};
